@if (loading) {
  <div class="load-indicator-container">
    <p>{{ translation?.loading }}</p>
    <abc-load-indicator></abc-load-indicator>
  </div>
} @else {
  @if (resultsEmpty || !data) {
    <div class="message-container">
      @if (!loading) {
        <p>
          {{ translation?.resultMessage.clickMessage }} '{{ translation?.resultMessage.button }}'
          <span class="dx-icon dx-icon-fieldchooser"></span>{{ translation?.resultMessage.viewMessage }}
        </p>
      }
    </div>
  } @else {
    @if (data) {
      <abc-opath-queries-editor-nested-grid
        #nestedGrid
        [data]="data"
        [query]="query"
        [level]="0"
      ></abc-opath-queries-editor-nested-grid>
    }
  }
}

